export const OtherChargesdata = {
  columns: [
    { id: "CHARGETYPE", label: "CHARGE TYPE", width: 70 },
    {
      id: "CHARGEFOR",
      label: "CHARGE FOR",
      width: 130,
      textAlign: "center",
      flexDirection: "row-reverse",
      valueGetter: (params) => {
        const valueMap = {
          G: "Gross",
          N: "Nett",
        };
        return valueMap[params.row.CHARGEFOR] || params.row.CHARGEFOR;
      },
    },

    {
      id: "CHARGERATE",
      label: "CHARGE RATE (%)",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],
  rows: [],
  name: "Other Charges",
};

export const catergorydata = {
  columns: [
    {
      id: "MENUCATNAME",
      label: "Category NAME",
      width: 10,
      textAlign: "left",
    },
    // { id: 'COLORCODE', label: 'COLORCODE', width: 200,textAlign: "center",  backgroundColor: "COLORCODE", },
  ],
  rows: [],
  name: "Categories",
};

export const pcatergorydata = {
  columns: [
    {
      id: "MENUCATNAME",
      label: "Category NAME",
      width: 10,
      textAlign: "left",
    },
    // { id: 'COLORCODE', label: 'COLORCODE', width: 200,textAlign: "center",  backgroundColor: "COLORCODE", },
  ],
  rows: [],
  name: "Promotional Menu Category",
};

export const Itemdata = {
  columns: [
    { id: "MENUNAME", label: "MENU NAME", width: 70, flexDirection: "row" },
    // { id: "MENUCODE", label: "MENU CODE", width: 70, flexDirection: "row" },
    // {
    //   id: "MEASURINGUNIT",
    //   label: "MEASURING UNIT",
    //   width: 200,
    //   textAlign: "center",
    //   flexDirection: "row-reverse",
    // },
    // { id: 'MENUCODE', label: ' MENUCODE', width: 130,textAlign: "right",flexDirection: 'row-reverse' },
    {
      id: "DISCOUNT",
      label: "  DISCOUNT",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "RATE",
      label: "RATE",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],
  rows: [],

  name: " Items",
};

export const schedulegdata = {
  columns: [
    { id: "", label: "GUEST NAME", width: 40 },
    { id: "", label: "CONTACT NUMBER", width: 40, textAlign: "CENTER" },
    { id: "", label: "DATE", width: 40, textAlign: "CENTER" },
    { id: "", label: "START TIME", width: 40, textAlign: "CENTER" },
    { id: "", label: "END TIME", width: 40, textAlign: "CENTER" },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Schedule Details",
};

export const Receiptdata = {
  columns: [
    { id: "HEADER", label: "HEADER", width: 70 },
    { id: "FOOTER", label: "FOOTER", width: 130 },

    { id: "REFPOLICY", label: "REFPOLICY", width: 200 },
    { id: "TERMS", label: "TERMS", width: 200 },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Receipt Details",
};

export const Waitersdata = {
  columns: [
    { id: "NAME", label: "NAME", width: 70 },

    // { id: "ENUSER", label: "ENUSER", width: 130, textAlign: "center" },
  ],
  rows: [],

  name: "Waiters Details",
};

export const Printersdata = {
  columns: [
    { id: "PRINTERNAME", label: "PRINTER NAME", width: 70, textAlign: "left" },
    // { id: "MENUTYPECODE", label: "MENUTYPECODE", width: 200, textAlign: "left" },

    { id: "PRINTERIP", label: "PRINTER IP", width: 200, textAlign: "left" },
  ],

  name: "Printer Details",
};

export const Barcodedata = {
  columns: [],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Barcode",
};

export const ManageOrderdata = {
  columns: [
    { id: "id", label: "ID", width: 70 },
    { id: "name", label: "Name", width: 130 },
    { id: "catergory", label: "catergory", width: 200 },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Manage Order",
};

export const Orderlistdata = {
  columns: [
    { id: "ORDERCODE", label: "ORDER CODE", width: 70 },
    {
      id: "STS",
      label: "Status",
      width: 200,
      flexDirection: "row-reverse",
    },
    { id: "ORDERENDATE", label: "ORDER DATE", width: 130 },
    {
      id: "AMOUNT",
      label: "AMOUNT",
      width: 200,
    },
  ],
  name: "Order List",
};

export const OfficerManageOrderData = {
  columns: [
    { id: "id", label: "Item", width: 70 },
    { id: "qty", label: "Qty.", width: 130 },
    { id: "rate", label: "Rate", width: 200 },
    { id: "amount", label: "Amount", width: 200 },
  ],
  rows: [
    {
      id: 1,
      qty: "Charge 1",
      rate: "Description for charge 1",
      amount: "Description for charge 2",
    },
    {
      id: 2,
      qty: "Charge 2",
      rate: "Description for charge 2",
      amount: "Description for charge 2",
    },
  ],

  name: "Manage Order",
};

export const OfficerOrdersData = {
  columns: [
    { id: "requestid", label: "Request ID", width: 70 },
    { id: "orderid", label: "Order ID", width: 130 },
    { id: "table", label: "Table", width: 200 },
  ],
  rows: [
    {
      id: 1,
      requestid: "Charge 1",
      orderid: "Description for charge 1",
      table: "Description for charge 2",
    },
    {
      id: 2,
      requestid: "Charge 2",
      orderid: "Description for charge 2",
      table: "Description for charge 2",
    },
  ],

  name: "Orders",
};

export const Ordercanceldata = {
  columns: [
    { id: "id", label: "ID", width: 70 },
    { id: "name", label: "Name", width: 130 },
    { id: "catergory", label: "catergory", width: 200 },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Order cancel",
};

export const Addonsdata = {
  columns: [
    { id: "ADDONTYPE", label: "ADDON TYPE", width: 70 },
    { id: "DESCRIP", label: "DESCRIPtion", width: 130 },
    { id: "RATE", label: "RATE", width: 200 },
  ],

  name: "Addons Details",
};

export const ordertrackingdata = {
  columns: [
    { id: "ORDERSTATUS", label: "TRACKING TYPE", width: 200 },
    { id: "ENUSER", label: "USER", width: 200 },
    { id: "SMSTEXT", label: "SEND SMS", width: 200 },
    { id: "STS", label: "Status", width: 200, textAlign: "center" },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Order Tracking Details",
};

export const Tablesdata = {
  columns: [
    {
      id: "COLORCODE",
      label: "COLOR CODE",
      width: 200,
      textAlign: "center",
      backgroundColor: "COLORCODE",
    },
    // { id: "STS", label: "STATUS", width: 200, textAlign: "center" },
    { id: "TABLENAME", label: "TABLE NAME", width: 70, textAlign: "center" },
    { id: "NOOFSEATS", label: "NO OF SEATS", width: 130, textAlign: "center" },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Table Details",
};

export const stockdata = {
  columns: [
    { id: "FULLNAME", label: "Suppiler NAME", width: 200, textAlign: "left" },
    {
      id: "GROSSAMT",
      label: "GROSS Amount",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "NETTAMT",
      label: "NET Amount",
      width: 70,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "TAXAMT",
      label: "TAX Amount",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "DISCOUNT",
      label: "DISCOUNT Amount",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "INVOICENO",
      label: "INVOICE No",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "INVOICEDATE",
      label: "INVOICE Date",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],

  name: "GRN Details",
};

export const stockdetaildata = {
  columns: [
    { id: "MENUNAME", label: "MENU NAME", width: 200, textAlign: "left" },
    {
      id: "RATE",
      label: "RATE",
      width: 70,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "SELLINGRATE",
      label: "SELLINg GRATE",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "QTY",
      label: "QTY",
      width: 70,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "TAXAMT",
      label: "TAX AMT",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "DISCOUNT",
      label: "DISCOUNT",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],

  name: "Stock Details",
};

export const Menumealdata = {
  columns: [
    { id: "MENUNAME", label: "MENU NAME", width: 70 },
    {
      id: "ITEMRATE",
      label: "ITEM RATE",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "MEASURINGUNIT",
      label: "MEASURING UNIT",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Menu/Meal Details",
};

export const Promotiondata = {
  columns: [
    { id: "MENUNAME", label: "MENU NAME", width: 70 },
    {
      id: "PROMOCODE",
      label: "PROMO CODE",
      width: 130,
      textAlign: "center",
      flexDirection: "row-reverse",
    },
    {
      id: "RATE",
      label: "RATE",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "FROMDATE",
      label: "FROM DATE",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Promotion Details",
};

export const Membershipdata = {
  columns: [
    { id: "GROUPNAME", label: "GROUP NAME", width: 70 },
    {
      id: "DISCOUNT",
      label: "DISCOUNT",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "AMOUNTFORPOINTS",
      label: "AMOUNT FOR POINTS",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "POINTSFORAMOUNT",
      label: "POINTS FOR Amt",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },

    {
      id: "AMOUNTTOPOINTS",
      label: "AMOUNT TO POINTS",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "POINTSTOAMOUNT",
      label: "POINTS TO AMt",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Membership Details",
};

export const Suppilerdata = {
  columns: [
    { id: "FIRSTNAME", label: "FIRST NAME", width: 70 },
    {
      id: "EMAIL",
      label: "EMAIL",
      width: 130,
      textAlign: "left",
    },
    {
      id: "CONTACTNO",
      label: "CONTACT NO",
      width: 200,
      textAlign: "left",
    },
    {
      id: "CREDITLIMIT",
      label: "CREDIT LIMIT",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    // { id: 'SUPREFCODE', label: 'SUPREF CODE', width: 200,textAlign: "right",flexDirection: 'row-reverse' },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Suppiler Details",
};

export const Customerdata = {
  columns: [
    { id: "FIRSTNAME", label: "FIRST NAME", width: 130 },
    { id: "LASTNAME", label: "LAST NAME", width: 200 },
    { id: "EMAIL", label: "EMAIL", width: 200 },
    { id: "CONTACTNO", label: "CONTACT NO", width: 200 },
    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Customer Details",
};

export const Giftcertificatedata = {
  columns: [
    { id: "GIFTNAME", label: "GIFT NAME", width: 70 },
    {
      id: "AMOUNT",
      label: "AMOUNT",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "EXPIRYDATE",
      label: "EXPIRY DATE",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],

  name: "Gift Certificate",
};

export const Giftvoucherdata = {
  columns: [
    { id: "VOUCHERNO", label: "VOUCHER NO", width: 70 },
    {
      id: "BARCODE",
      label: "BARCODE",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],

  name: "Gift Voucher",
};

export const Mapuserdata = {
  columns: [
    { id: "USERGROUP", label: "USERGROUP", width: 70 },
    {
      id: "USERNAME",
      label: "User Name",
      width: 130,
      textAlign: "left",
    },
    {
      id: "GROUPNAME",
      label: "Group Name",
      width: 200,
      textAlign: "left",
    },
    {
      id: "STARTDATE",
      label: "Start Date",
      width: 200,
      textAlign: "left",
    },
  ],

  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: " Map user Details",
};

export const locationdata = {
  columns: [
    { id: "LOCATION", label: "LOCATION", width: 70 },
    { id: "ADDRESS", label: "ADDRESS ", width: 130, textAlign: "Left" },
  ],

  name: "Location Details",
};

export const parameterdata = {
  columns: [
    { id: "GROUPCODE", label: "LOCATION NAME", width: 70 },
    { id: "GROUPNAME", label: "HOTLINE", width: 65, textAlign: "CENTER" },
    { id: "GROUPNAME", label: "EMAIL ", width: 65, textAlign: "CENTER" },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Parameter Details",
};

export const dayenddata = {
  columns: [
    { id: "LOCATION", label: "LOCATION NAME", width: 70 },
    {
      id: "CONTATCPERSON",
      label: "CONTACT PERSON",
      width: 65,
      textAlign: "left",
    },
    {
      id: "SYSDATE",
      label: "System Date",
      width: 65,
      textAlign: "center",
      flexDirection: "row-reverse",
    },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Dayend Process Details",
};

export const usergroupdata = {
  columns: [
    { id: "GROUPNAME", label: "GROUP NAME", width: 70 },
    {
      id: "STS",
      label: "STATUS ",
      width: 65,
      flexDirection: "row-reverse",
      textAlign: "CENTER",
    },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "User Group Details",
};

export const userdata = {
  columns: [
    { id: "USERNAME", label: "USER NAME", width: 70, textAlign: "left" },
    { id: "GROUPNAME", label: "USER GROUP ", width: 65, textAlign: "left" },
    // { id: "COMPNAME", label: "LOCATION ", width: 65, textAlign: "left" },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "User Accounts",
};

export const sessiondata = {
  columns: [
    { id: "USERNAME", label: "USER NAME", width: 70 },
    { id: "ENDATE", label: "Date & TIME", width: 65, textAlign: "center" },
    { id: "LOGSTS", label: "Login Status", width: 65, textAlign: "center" },

    // Add more column definitions as needed
  ],

  name: "Login Sessions",
};

export const userlogdata = {
  columns: [
    { id: "REASON", label: "LOG DETAILS", width: 100, textAlign: "left" },
    { id: "ENUSER", label: "Email", width: 100, textAlign: "left" },
    { id: "LOCDATE", label: "Log Date", width: 100, textAlign: "center" },
    { id: "ENDATE", label: "Entered Date", width: 100, textAlign: "center" },

    // Add more column definitions as needed
  ],

  name: "User Logs",
};

export const maplocationdata = {
  columns: [
    { id: "GROUPCODE", label: "AVAILABLE LOCATION", width: 70 },
    { id: "GROUPNAME", label: "SELECT", width: 65, textAlign: "CENTER" },
    { id: "GROUPNAME", label: "STATUS ", width: 65, textAlign: "CENTER" },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Map Locations",
};

export const paymenthistorydata = {
  columns: [
    { id: "INVOICENO", label: "INVOICE NO", width: 70 },
    { id: "DUETODATE", label: "DUE DATE ", width: 130, textAlign: "center" },
    {
      id: "NEXTDUEDATE",
      label: "BILLING PERIOD ",
      width: 130,
      textAlign: "center",
    },
    {
      id: "LICENSEVALUE",
      label: "LICENSE VALUE ",
      width: 130,
      textAlign: "right",
    },
    { id: "NETTVALUE", label: "NET VALUE ", width: 130, textAlign: "right" },
    { id: "DISCOUNT", label: "DISCOUNT", width: 130, textAlign: "right" },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Payment History",
};

export const Billinghistorydata = {
  columns: [
    { id: "INVOICENO", label: "INVOICE NO", width: 70 },
    { id: "DUETODATE", label: "DUE DATE ", width: 130, textAlign: "center" },
    {
      id: "NEXTDUEDATE",
      label: "NEXT DUE DATE ",
      width: 130,
      textAlign: "center",
    },
    {
      id: "LICENSEVALUE",
      label: "LICENSE VALUE ",
      width: 130,
      textAlign: "right",
    },
    { id: "NETTVALUE", label: "NET VALUE ", width: 130, textAlign: "right" },
    { id: "DISCOUNT", label: "DISCOUNT", width: 130, textAlign: "right" },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Current Billings",
};

export const billingdata = {
  columns: [
    { id: "GROUPCODE", label: "INVOICE NO.", width: 70 },
    { id: "GROUPNAME", label: "DUE DATE ", width: 130, textAlign: "CENTER" },
    {
      id: "GROUPNAME",
      label: "BILLING PERIOD ",
      width: 130,
      textAlign: "CENTER",
    },
    { id: "GROUPNAME", label: "DUE AMOUNT ", width: 130, textAlign: "CENTER" },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Current Billings",
};

export const shopdata = {
  columns: [
    // { id: "RESTCODE", label: "RESTCODE", width: 70 },
    { id: "RESTNAME", label: "Shop Name", width: 70 },
    { id: "BUSINESSTYPE", label: "BUSINESS TYPE", width: 70 },
    {
      id: "DESCRIPTION",
      label: "DESCRIPTION",
      width: 130,
      textAlign: "left",
    },

    // {
    //   id: "ADDRESS1",
    //   label: "ADDRESS",
    //   width: 130,
    //   textAlign: "left",
    // },
    // {
    //   id: "ADDRESS2",
    //   label: "ADDRESS Line 2",
    //   width: 130,
    //   textAlign: "left",
    // },
    // {
    //   id: "ADDRESS3",
    //   label: "ADDRESS Line 3",
    //   width: 130,
    //   textAlign: "left",
    // },
    { id: "EMAIL", label: "EMAIL", width: 130, textAlign: "left" },
    { id: "HOTLINE", label: "HOTLINE", width: 130, textAlign: "left" },
    // { id: "FAX", label: "Fax", width: 130, textAlign: "left" },

    // {
    //   id: "BUSINESSTYPECODE",
    //   label: "BUSINESS TYPE CODE",
    //   width: 130,
    //   textAlign: "left",
    // },
    // {
    //   id: "SALESSTYLETYPE",
    //   label: "SALES STYLE TYPE",
    //   width: 130,
    //   textAlign: "left",
    // },
    // { id: "ISCHAIN", label: "IS CHAIN", width: 130, textAlign: "left" },
    // { id: "OPRDATE", label: "OPR DATE", width: 130, textAlign: "left" },

    // Add more column definitions as needed
  ],
  // rows: [{ id: 1, RESTCODE: "SC001", DESCRIPTION: "Shop A", PIN: "123456" }],

  name: "Shop Details",
};

export const Emailsetupdata = {
  columns: [
    { id: "MAILACTION", label: "Mail Action ", width: 100 },
    { id: "INTERVAL", label: "Interval ", width: 30, textAlign: "CENTER" },
    { id: "SUBJECT", label: "Mail Subject ", width: 130 },

    // Add more column definitions as needed
  ],
 

  name: "Email Setup",
};

export const SMSsetupdata = {
  columns: [
    { id: "SMSACTION", label: "SMS Action ", width: 100 },
    // { id: "INTERVAL", label: "Interval ", width: 30, textAlign: "CENTER" },
    { id: "BODYTEXT", label: "BODYTEXT", width: 130 },
     { id: "TONO", label: "TO Number", width: 130 },

    // Add more column definitions as needed
  ],
 

  name: "SMS Setup",
};

export const taxtypedata = {
  columns: [
    { id: "GROUPCODE", label: "TAX AND CHARGES TYPE", width: 70 },
    { id: "GROUPNAME", label: "RATE", width: 130, textAlign: "CENTER" },
    { id: "GROUPNAME", label: "APPLIED FOR ", width: 130, textAlign: "CENTER" },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Taxes and Charges Type",
};

export const Taxdata = {
  columns: [
    { id: "TAXTYPE", label: "TAX TYPE", width: 70 },
    {
      id: "TAXRATE",
      label: "Tax / Charges Rate [%]",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },

    {
      id: "TAXAPPLIEDFOR",
      label: "TAX APPLIED FOR ",
      width: 130,
      textAlign: "center",
      flexDirection: "row-reverse",
      valueGetter: (params) => {
        const valueMap = {
          G: "Gross",
          N: "Nett",
        };
        return valueMap[params.row.TAXAPPLIEDFOR] || params.row.TAXAPPLIEDFOR;
      },
    },
  ],

  name: "Taxes & Charges Types",
};
